import { Pipe, PipeTransform } from '@angular/core';
import { Person } from '../interfaces/person';


export interface PersonNameOptions {
  withSalutation: boolean;
  lastNameFirst: boolean;
}

/**
 * Gibt den kompletten Namen (Vorname + Nachname) des Kunden aus
 */
@Pipe({name: 'personName' })
export class PersonNamePipe implements PipeTransform {
  transform(value: Person, withSalutation: boolean = false, lastNameFirst: boolean = false): string {
    const salutation = value.Salutation;
    const firstName = value.FirstName;
    const lastName = value.LastName;
    let fullName = `${firstName} ${lastName}`;

    if (lastNameFirst) {
      fullName = `${lastName}, ${firstName}`;
    }

    if (withSalutation) {
      return `${salutation} ${fullName}`
    }

    return fullName;
  }
}